/* HolzWurmDesign – Wurmkorb v6

   Vier Aufgaben im Warenkorb (Seite und Schublade):
   1. Gravur-Vorschau als Artikelbild zeigen, statt des Produktfotos.
   2. Knopf "Gestaltung bearbeiten" an jede konfigurierte Position haengen.
   3. Mengen-Limit 250 je Position mit Auto-Korrektur (Tippfehler-Schutz).
   4. Fotogravur-Aufpreis mit seiner Gravur-Position zusammenhalten.

   Zum Aufpreis: Der Flaechen-Konfigurator legt je hochgeladenem Foto das
   Produkt "Aufpreis Fotogravur" mit in den Warenkorb. Die Gravur-Position
   traegt _hwd_verbund (Kennung), _hwd_fotos (Anzahl) und _hwd_aufpreis_id
   (Variante des Aufpreises), die Aufpreis-Position _hwd_aufpreis mit
   derselben Kennung. Hier wird abgeglichen: Faellt die Gravur weg, faellt
   der Aufpreis weg; stimmt die Anzahl nicht, wird sie korrigiert; fehlt er,
   wird er nachgelegt. Mengenfeld und Entfernen-Knopf des Aufpreises sind
   ausgeblendet - er richtet sich allein nach der Gravur.

   Zum Bearbeiten: Die Konfiguratoren (Fotogravur wie Zippo) legen beim Kauf
   ihren Entwurf unter einer Kennung im lokalen Speicher ab und haengen sie
   als verstecktes Merkmal _hwd an die Position. Der Knopf ruft die
   Produktseite mit ?hwd=<Kennung>&hwd_key=<Position> auf und legt vorher die
   Adressen der hochgeladenen Dateien in den Sitzungsspeicher, damit der
   Konfigurator sie nachholen kann - beim Foto heissen sie "Originalfoto n",
   beim Zippo "Originalmotiv n". Der aeltere Gravur-Konfigurator (_Layout)
   bekommt wie bisher seinen Link mit ?hwd_edit=<Position>.

   Der Knopf haengt im Textblock der Position (.cart-item__details), nicht
   an deren Elternknoten: die Warenkorbseite ist eine Tabelle, ein Link
   direkt in der Zeile wuerde aus dem Layout fallen. Seine Gestaltung steht
   hier im Skript, weil das Konfigurator-Stylesheet auf der Warenkorbseite
   nicht geladen ist.

   Mengen-Limit und Bildtausch laufen nur auf der Warenkorbseite, der
   Bearbeiten-Knopf auch in der Schublade.
*/
(function () {
  'use strict';
  var MAXQ = 250;
  var aufKorbseite = location.pathname.indexOf('/cart') === 0;
  var KNOPFSTIL = 'display:inline-block;margin-top:1rem;padding:.6rem 1.1rem;font-size:1.25rem;'
    + 'font-weight:600;color:#96501F;text-decoration:none;border:1px solid rgba(180,98,45,.45);'
    + 'border-radius:8px;background:rgba(180,98,45,.08);';

  var applying = false;
  var healTries = 0;

  function norm(u) {
    if (!u) return null;
    u = String(u).trim();
    if (u.indexOf('//') === 0) u = 'https:' + u;
    else if (u.indexOf('/') === 0) u = location.origin + u;
    if (!/^https?:\/\//i.test(u)) return null;
    var path = u.split(/[?#]/)[0];
    if (!/\.(png|jpe?g|webp|gif|svg)$/i.test(path)) return null;
    return u;
  }

  function showNote() {
    if (document.getElementById('hwdQtyCapNote')) return;
    var n = document.createElement('div');
    n.id = 'hwdQtyCapNote';
    n.textContent = 'ℹ️ Maximal ' + MAXQ + ' Stück pro Position – die Menge wurde angepasst. Größere Mengen gern über die Firmen-Anfrage.';
    n.style.cssText = 'position:fixed;top:18px;right:18px;background:#4A3826;color:#F6F0E4;border-radius:12px;padding:12px 16px;font-size:13px;font-weight:600;box-shadow:0 12px 30px rgba(30,20,5,.3);z-index:60;max-width:340px;';
    document.body.appendChild(n);
    setTimeout(function () { n.remove(); }, 5000);
  }

  function clampInputs() {
    var inputs = document.querySelectorAll('input.quantity__input, .cart-item input[type="number"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      inp.setAttribute('max', MAXQ);
      if (!inp.__hwdClamped) {
        inp.__hwdClamped = true;
        inp.addEventListener('change', function () {
          var v = parseInt(this.value, 10) || 1;
          if (v > MAXQ) { this.value = MAXQ; showNote(); this.dispatchEvent(new Event('input', { bubbles: true })); }
          if (v < 1) this.value = 1;
        });
      }
      if ((parseInt(inp.value, 10) || 1) > MAXQ) inp.value = MAXQ;
    }
  }

  function heal(cart) {
    if (healTries >= 5) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.quantity > MAXQ) {
        healTries++;
        showNote();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: MAXQ })
        }).then(function () { location.reload(); }).catch(function () {});
        return true;
      }
    }
    return false;
  }

  /* Warenkorbseite und Schublade getrennt behandeln: in beiden stehen die
     Positionen in derselben Reihenfolge wie in /cart.js, aber sie duerfen
     nicht in einen Topf geworfen werden. */
  function behaelter() {
    var liste = [];
    var seite = document.getElementById('main-cart-items') || document.querySelector('cart-items');
    if (seite) liste.push(seite);
    var lade = document.querySelector('cart-drawer');
    if (lade) liste.push(lade);
    return liste;
  }

  /* Bei mehreren Flaechen heisst die Vorschau etwa "Gravurvorschau
     Laengsseiten" - dann nimmt der Korb die erste, die es gibt. */
  function ersteVorschau(p) {
    var keys = Object.keys(p);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf('Gravurvorschau') !== 0) continue;
      var u = norm(p[keys[i]]);
      if (u) return u;
    }
    return null;
  }

  function bildTauschen(row, p) {
    var pick = norm(p.Gravurvorschau) || norm(p['Gravurvorschau Vorderseite']) || ersteVorschau(p)
      || norm(p.Vorschau) || norm(p.Foto) || norm(p['Foto-Link']);
    var img = row.querySelector('.cart-item__image');
    if (!img || !pick || img.getAttribute('src') === pick) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = pick;
    img.style.objectFit = 'cover';
    img.style.background = '#FFFDF8';
    img.style.border = '1px solid #EADFC9';
    img.style.borderRadius = '10px';
  }

  function linksAufraeumen(row) {
    var links = row.querySelectorAll('a[href*="upload"], dd a, .product-option a');
    for (var l = 0; l < links.length; l++) {
      var a = links[l];
      var txt = (a.textContent || '').trim();
      if (/\.(png|jpe?g|webp|gif|pdf|svg)$/i.test(txt.split(/[?#]/)[0]) || (txt.length > 24 && /^[a-f0-9]{16,}/i.test(txt))) {
        a.textContent = 'Datei öffnen';
        a.target = '_blank';
      }
    }
  }

  /* Reihenfolge ist wichtig: der Konfigurator ordnet die Adressen genau in
     dieser Folge wieder seinen Elementen zu. */
  function dateiAdressen(p) {
    var liste = [];
    Object.keys(p).forEach(function (k) {
      var m = /^Original(?:foto|motiv)\s*(\d+)/.exec(k);
      if (m && norm(p[k])) liste.push({ n: parseInt(m[1], 10), u: p[k] });
    });
    liste.sort(function (x, y) { return x.n - y.n; });
    return liste.map(function (x) { return x.u; });
  }

  function bearbeitenKnopf(row, it) {
    if (row.querySelector('.hwd-editlink')) return;
    var p = it.properties || {};
    var entwurf = p._hwd;
    var basis = String(it.url || '').split('?')[0];
    if (!basis) return;

    var ziel = null;
    if (entwurf) {
      ziel = basis + '?hwd=' + encodeURIComponent(entwurf) + '&hwd_key=' + encodeURIComponent(it.key);
    } else if (p._Layout || p._gravur_elemente) {
      ziel = basis + '?hwd_edit=' + encodeURIComponent(it.key);
    }
    if (!ziel) return;

    var host = row.querySelector('.cart-item__details') || row.querySelector('.cart-item__name');
    if (!host) return;

    var a = document.createElement('a');
    a.className = 'hwd-editlink';
    a.href = ziel;
    a.textContent = '✏️ Gestaltung bearbeiten';
    a.style.cssText = KNOPFSTIL;
    if (entwurf) {
      var dateien = dateiAdressen(p);
      a.addEventListener('click', function () {
        try { sessionStorage.setItem('hwd-fotos-' + entwurf, dateien.join('\n')); } catch (e) { /* dann eben neu waehlen */ }
      });
    }
    host.appendChild(a);
  }

  /* ---------- Fotogravur-Aufpreis ---------- */
  function aufpreisSoll(cart) {
    var haupt = {}, zusatz = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._hwd_aufpreis) {
        (zusatz[p._hwd_aufpreis] = zusatz[p._hwd_aufpreis] || []).push(it);
      } else if (p._hwd_verbund) {
        haupt[p._hwd_verbund] = { fotos: parseInt(p._hwd_fotos, 10) || 0, id: p._hwd_aufpreis_id, titel: it.product_title };
      }
    });
    var updates = {}, neu = [], etwas = false;
    Object.keys(zusatz).forEach(function (v) {
      var soll = haupt[v] ? haupt[v].fotos : 0;
      zusatz[v].forEach(function (it, i) {
        var q = i === 0 ? soll : 0;
        if (it.quantity !== q) { updates[it.key] = q; etwas = true; }
      });
    });
    Object.keys(haupt).forEach(function (v) {
      var h = haupt[v];
      if (h.fotos > 0 && !zusatz[v] && h.id) {
        neu.push({ id: parseInt(h.id, 10), quantity: h.fotos,
          properties: { _hwd_aufpreis: v, 'Für': h.titel || '' } });
        etwas = true;
      }
    });
    return etwas ? { updates: updates, neu: neu } : null;
  }

  /* Schutz vor einer Endlosschleife, falls der Shop eine Aenderung nicht
     annimmt: hoechstens drei Abgleiche je Minute. */
  function abgleichErlaubt() {
    try {
      var jetzt = Date.now();
      var liste = JSON.parse(sessionStorage.getItem('hwd-abgleich') || '[]')
        .filter(function (t) { return jetzt - t < 60000; });
      if (liste.length >= 3) return false;
      liste.push(jetzt);
      sessionStorage.setItem('hwd-abgleich', JSON.stringify(liste));
    } catch (e) { /* ohne Speicher: einmal pro Seitenaufruf */ if (abgleichLief) return false; }
    abgleichLief = true;
    return true;
  }
  var abgleichLief = false;

  function schubladeErneuern(sec) {
    if (!sec) return;
    var lade = document.querySelector('cart-drawer');
    if (lade && sec['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
      var neu = doc.querySelector('#CartDrawer'), alt = document.getElementById('CartDrawer');
      if (neu && alt) {
        alt.innerHTML = neu.innerHTML;
        var ov = document.getElementById('CartDrawer-Overlay');
        if (ov && lade.close) ov.addEventListener('click', function () { lade.close(); });
      }
      var kopf = doc.querySelector('cart-drawer');
      if (kopf) lade.classList.toggle('is-empty', kopf.classList.contains('is-empty'));
    }
    var blase = document.getElementById('cart-icon-bubble');
    if (blase && sec['cart-icon-bubble']) {
      var d2 = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
      var innen = d2.querySelector('.shopify-section');
      if (innen) blase.innerHTML = innen.innerHTML;
    }
  }

  function aufpreisAbgleichen(cart) {
    var soll = aufpreisSoll(cart);
    if (!soll || !abgleichErlaubt()) return false;
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var kette = Promise.resolve();
    if (Object.keys(soll.updates).length) {
      kette = kette.then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: soll.updates }) });
      });
    }
    if (soll.neu.length) {
      kette = kette.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: soll.neu }) });
      });
    }
    kette.then(function () {
      if (aufKorbseite) { location.reload(); return; }
      var basis = (window.routes && window.routes.cart_url) || '/cart';
      return fetch(basis + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(schubladeErneuern);
    }).catch(function () {});
    return true;
  }

  function aufpreisZeile(row) {
    if (row.getAttribute('data-hwd-aufpreis') === '1') return;
    row.setAttribute('data-hwd-aufpreis', '1');
    ['quantity-input', 'cart-remove-button', '.quantity-popover__info-button'].forEach(function (sel) {
      [].slice.call(row.querySelectorAll(sel)).forEach(function (x) { x.style.display = 'none'; });
    });
    var host = row.querySelector('.cart-item__quantity-wrapper') || row.querySelector('.cart-item__details');
    if (!host) return;
    var n = document.createElement('p');
    n.textContent = 'je Foto · wird automatisch berechnet';
    n.style.cssText = 'margin:.4rem 0 0;font-size:1.2rem;line-height:1.4;color:rgba(18,18,18,.6)';
    host.appendChild(n);
  }

  function apply(cart) {
    if (aufpreisAbgleichen(cart)) return;
    if (aufKorbseite) {
      if (heal(cart)) return;
      clampInputs();
    }
    var boxen = behaelter();
    if (!boxen.length) return;
    applying = true;
    try {
      boxen.forEach(function (box) {
        var rows = box.querySelectorAll('.cart-item');
        if (!rows.length) return;
        cart.items.forEach(function (it, i) {
          var row = rows[i];
          if (!row) return;
          if (aufKorbseite) {
            bildTauschen(row, it.properties || {});
            linksAufraeumen(row);
          }
          if ((it.properties || {})._hwd_aufpreis) aufpreisZeile(row);
          else bearbeitenKnopf(row, it);
        });
      });
    } finally {
      setTimeout(function () { applying = false; }, 50);
    }
  }

  var debounceT = null;
  function run() {
    if (!behaelter().length) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }
  function scheduleRun() {
    if (applying) return;
    clearTimeout(debounceT);
    debounceT = setTimeout(run, 250);
  }

  function start() {
    run();
    var beobachter = new MutationObserver(function () { scheduleRun(); });
    behaelter().forEach(function (box) { beobachter.observe(box, { childList: true, subtree: true }); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
